interface IIcon {
  width?: string;
  color?: string;
  height?: string;
}
const DollarCircleFileIcon = ({ width = '16', color = '#AAAAAA', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_528_8809)">
      <path
        d="M13.5439 0.274414V3.12495H16.3943L13.5439 0.274414Z"
        fill={color}
        fillOpacity="0.5"
      />
      <path
        d="M13.0752 4.0625C12.8163 4.0625 12.6064 3.85262 12.6064 3.59375V0H5.8877C5.11229 0 4.48145 0.630844 4.48145 1.40625V6.64653C4.63588 6.63253 4.79216 6.625 4.9502 6.625C6.54795 6.625 7.97823 7.3555 8.92476 8.5H14.0127C14.2716 8.5 14.4814 8.70988 14.4814 8.96875C14.4814 9.22762 14.2716 9.4375 14.0127 9.4375H9.54232C9.83532 10.0092 10.0243 10.6427 10.0849 11.3125H14.0127C14.2716 11.3125 14.4814 11.5224 14.4814 11.7812C14.4814 12.0401 14.2716 12.25 14.0127 12.25H10.0849C9.94473 13.7981 9.1176 15.1508 7.91138 16H15.2627C16.0381 16 16.6689 15.3692 16.6689 14.5938V4.0625H13.0752ZM14.0127 6.625H7.1377C6.87882 6.625 6.66895 6.41512 6.66895 6.15625C6.66895 5.89738 6.87882 5.6875 7.1377 5.6875H14.0127C14.2716 5.6875 14.4814 5.89738 14.4814 6.15625C14.4814 6.41512 14.2716 6.625 14.0127 6.625Z"
        fill={color}
        fillOpacity="0.5"
      />
      <path
        d="M4.9502 7.5625C2.62398 7.5625 0.731445 9.45503 0.731445 11.7812C0.731445 14.1075 2.62398 16 4.9502 16C7.27641 16 9.16895 14.1075 9.16895 11.7812C9.16895 9.45503 7.27641 7.5625 4.9502 7.5625ZM4.68979 11.3125H5.21063C5.75626 11.3125 6.2002 11.7564 6.2002 12.3021V12.8229C6.2002 13.2971 5.86488 13.6943 5.41895 13.7902V13.9688C5.41895 14.2276 5.20907 14.4375 4.9502 14.4375C4.69132 14.4375 4.48145 14.2276 4.48145 13.9688V13.7902C4.03551 13.6943 3.7002 13.2971 3.7002 12.8229C3.7002 12.564 3.91007 12.3542 4.16895 12.3542C4.42782 12.3542 4.6377 12.564 4.6377 12.8229C4.6377 12.8516 4.66107 12.875 4.68979 12.875H5.21063C5.23935 12.875 5.26273 12.8516 5.26273 12.8229V12.3021C5.26273 12.2734 5.23935 12.25 5.21063 12.25H4.68979C4.14413 12.25 3.7002 11.8061 3.7002 11.2604V10.7396C3.7002 10.2654 4.03551 9.86822 4.48145 9.77225V9.59375C4.48145 9.33487 4.69132 9.125 4.9502 9.125C5.20907 9.125 5.41895 9.33487 5.41895 9.59375V9.77225C5.86488 9.86822 6.2002 10.2654 6.2002 10.7396C6.2002 10.9985 5.99032 11.2083 5.73145 11.2083C5.47257 11.2083 5.2627 10.9985 5.2627 10.7396C5.2627 10.7109 5.23932 10.6875 5.2106 10.6875H4.68976C4.66104 10.6875 4.63766 10.7109 4.63766 10.7396V11.2604C4.6377 11.2891 4.66107 11.3125 4.68979 11.3125Z"
        fill={color}
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_528_8809">
        <rect width="16" height="16" fill="white" transform="translate(0.200195)" />
      </clipPath>
    </defs>
  </svg>
);

export default DollarCircleFileIcon;
